import { SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    name: "image",isBottom:true,
    lineWidth: 0, radio: true, imageRatio: true,disableAnchor:true,
}
export default[
    {
        id: uuid(),
        name: "电磁阀",
        type: SpriteTypes.sprite,
        image: "images/technology/1.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/1.png",
            ...options
        },
    },
    {
        id:uuid(),
        name: "电缆浮球",
        type: SpriteTypes.sprite,
        image: "images/technology/2.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/2.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "回流阀",
        type: SpriteTypes.sprite,
        image: "images/technology/3.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/3.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "反洗泵",
        type: SpriteTypes.sprite,
        image: "images/technology/4.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/4.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "搅拌机",
        type: SpriteTypes.sprite,
        image: "images/technology/5.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/5.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "流量计",
        type: SpriteTypes.sprite,
        image: "images/technology/6.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/6.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "泥泵",
        type: SpriteTypes.sprite,
        image: "images/technology/7.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/7.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "气泵1",
        type: SpriteTypes.sprite,
        image: "images/technology/8.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/8.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "切割机",
        type: SpriteTypes.sprite,
        image: "images/technology/9.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/9.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "爆气盘",
        type: SpriteTypes.sprite,
        image: "images/technology/10.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/10.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "连杆浮球",
        type: SpriteTypes.sprite,
        image: "images/technology/11.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/11.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "风机2",
        type: SpriteTypes.sprite,
        image: "images/technology/12.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/12.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "离心机",
        type: SpriteTypes.sprite,
        image: "images/technology/13.png",
        categrory: spriteCategory.valve,
        data: {
            image: "images/technology/13.png",
            ...options
        },
    }
]